<div class="institutional-fields" *ngIf="showInstitutionalFields">
  <lib-card [hideTitle]="true">
    <dl class="data-list">
      <dt *ngIf="visit?.attendingProvider">Attending Provider</dt>
      <dd *ngIf="visit?.attendingProvider">
        {{ visit?.attendingProvider | physicianDisplay }}
      </dd>
      <dt *ngIf="visit?.referringProvider">Referring Provider</dt>
      <dd *ngIf="visit?.referringProvider">
        {{ visit?.referringProvider | physicianDisplay }}
      </dd>
      <dt *ngIf="visit?.location">Location</dt>
      <dd *ngIf="visit?.location">
        {{ visit?.location?.name }}
      </dd>
      <dt *ngIf="visit?.supervisingProvider">Supervising Provider</dt>
      <dd *ngIf="visit?.supervisingProvider">
        {{ visit?.supervisingProvider | physicianDisplay }}
      </dd>
      <dt *ngIf="visit?.admissionType">Admission Type</dt>
      <dd *ngIf="visit?.admissionType">
        {{ visit?.admissionType?.displayName || '--' }}
      </dd>
      <dt *ngIf="visit?.principalProcedure">Principal Procedure</dt>
      <dd
        *ngIf="visit?.principalProcedure"
        [title]="visit?.principalProcedure?.code + ' ' + visit?.principalProcedure?.description"
      >
        {{ visit?.principalProcedure?.code }} : {{ visit?.principalProcedureDate | dateDisplay }}
      </dd>
      <dt *ngIf="visit?.admittingDiagnosisCode">Admitting Diagnosis</dt>
      <dd
        *ngIf="visit?.admittingDiagnosisCode"
        [title]="
          visit?.admittingDiagnosisCode?.displayName +
          '&#10;Present On Admission: ' +
          visit?.admittingDiagPresentOnAdmission
        "
      >
        {{ visit?.admittingDiagnosisCode?.code }}
      </dd>
      <dt *ngIf="visit?.pointOfOrigin">Point of Origin</dt>
      <dd *ngIf="visit?.pointOfOrigin">
        {{ visit?.pointOfOrigin?.displayName || '--' }}
      </dd>
      <dt
        *ngIf="
          visit?.otherProcedure1 ||
          visit?.otherProcedure2 ||
          visit?.otherProcedure3 ||
          visit?.otherProcedure4 ||
          visit?.otherProcedure5
        "
      >
        Other Procedures
      </dt>
      <dd
        *ngIf="
          visit?.otherProcedure1 ||
          visit?.otherProcedure2 ||
          visit?.otherProcedure3 ||
          visit?.otherProcedure4 ||
          visit?.otherProcedure5
        "
      >
        <div
          [title]="visit?.otherProcedure1?.code + ' ' + visit?.otherProcedure1?.description"
          *ngIf="visit?.otherProcedure1"
        >
          {{ visit?.otherProcedure1?.code }} : {{ visit?.otherProcedure1Date | dateDisplay }}
        </div>
        <div
          [title]="visit?.otherProcedure2?.code + ' ' + visit?.otherProcedure2?.description"
          *ngIf="visit?.otherProcedure2"
        >
          {{ visit?.otherProcedure2?.code }} : {{ visit?.otherProcedure2Date | dateDisplay }}
        </div>
        <div
          [title]="visit?.otherProcedure3?.code + ' ' + visit?.otherProcedure3?.description"
          *ngIf="visit?.otherProcedure3"
        >
          {{ visit?.otherProcedure3?.code }} : {{ visit?.otherProcedure3Date | dateDisplay }}
        </div>
        <div
          [title]="visit?.otherProcedure4?.code + ' ' + visit?.otherProcedure4?.description"
          *ngIf="visit?.otherProcedure4"
        >
          {{ visit?.otherProcedure4?.code }} : {{ visit?.otherProcedure4Date | dateDisplay }}
        </div>
        <div
          [title]="visit?.otherProcedure5?.code + ' ' + visit?.otherProcedure5?.description"
          *ngIf="visit?.otherProcedure5"
        >
          {{ visit?.otherProcedure5?.code }} : {{ visit?.otherProcedure5Date | dateDisplay }}
        </div>
      </dd>
      <dt
        *ngIf="
          visit?.diagnosis1 ||
          visit?.diagnosis2 ||
          visit?.diagnosis3 ||
          visit?.diagnosis4 ||
          visit?.diagnosis5 ||
          visit?.diagnosis6 ||
          visit?.diagnosis7 ||
          visit?.diagnosis8 ||
          visit?.diagnosis9 ||
          visit?.diagnosis10 ||
          visit?.diagnosis11 ||
          visit?.diagnosis12
        "
      >
        Diagnosis Codes
      </dt>
      <dd
        class="code-list"
        *ngIf="
          visit?.diagnosis1 ||
          visit?.diagnosis2 ||
          visit?.diagnosis3 ||
          visit?.diagnosis4 ||
          visit?.diagnosis5 ||
          visit?.diagnosis6 ||
          visit?.diagnosis7 ||
          visit?.diagnosis8 ||
          visit?.diagnosis9 ||
          visit?.diagnosis10 ||
          visit?.diagnosis11 ||
          visit?.diagnosis12
        "
      >
        <div
          *ngIf="visit?.diagnosis1"
          [title]="visit?.diagnosis1?.displayName + '&#10;Present On Admission: ' + visit?.diagnosis1PresentOnAdmission"
        >
          {{ visit?.diagnosis1?.code }}
        </div>
        <div
          *ngIf="visit?.diagnosis2"
          [title]="visit?.diagnosis2?.displayName + '&#10;Present On Admission: ' + visit?.diagnosis2PresentOnAdmission"
        >
          , {{ visit?.diagnosis2?.code }}
        </div>
        <div
          *ngIf="visit?.diagnosis3"
          [title]="visit?.diagnosis3?.displayName + '&#10;Present On Admission: ' + visit?.diagnosis3PresentOnAdmission"
        >
          , {{ visit?.diagnosis3?.code }}
        </div>
        <div
          *ngIf="visit?.diagnosis4"
          [title]="visit?.diagnosis4?.displayName + '&#10;Present On Admission: ' + visit?.diagnosis4PresentOnAdmission"
        >
          , {{ visit?.diagnosis4?.code }}
        </div>
        <div
          *ngIf="visit?.diagnosis5"
          [title]="visit?.diagnosis5?.displayName + '&#10;Present On Admission: ' + visit?.diagnosis5PresentOnAdmission"
        >
          , {{ visit?.diagnosis5?.code }}
        </div>
        <div
          *ngIf="visit?.diagnosis6"
          [title]="visit?.diagnosis6?.displayName + '&#10;Present On Admission: ' + visit?.diagnosis6PresentOnAdmission"
        >
          , {{ visit?.diagnosis6?.code }}
        </div>
        <div
          *ngIf="visit?.diagnosis7"
          [title]="visit?.diagnosis7?.displayName + '&#10;Present On Admission: ' + visit?.diagnosis7PresentOnAdmission"
        >
          , {{ visit?.diagnosis7?.code }}
        </div>
        <div
          *ngIf="visit?.diagnosis8"
          [title]="visit?.diagnosis8?.displayName + '&#10;Present On Admission: ' + visit?.diagnosis8PresentOnAdmission"
        >
          , {{ visit?.diagnosis8?.code }}
        </div>
        <div
          *ngIf="visit?.diagnosis9"
          [title]="visit?.diagnosis9?.displayName + '&#10;Present On Admission: ' + visit?.diagnosis9PresentOnAdmission"
        >
          , {{ visit?.diagnosis9?.code }}
        </div>
        <div
          *ngIf="visit?.diagnosis10"
          [title]="
            visit?.diagnosis10?.displayName + '&#10;Present On Admission: ' + visit?.diagnosis10PresentOnAdmission
          "
        >
          , {{ visit?.diagnosis10?.code }}
        </div>
        <div
          *ngIf="visit?.diagnosis11"
          [title]="
            visit?.diagnosis11?.displayName + '&#10;Present On Admission: ' + visit?.diagnosis11PresentOnAdmission
          "
        >
          , {{ visit?.diagnosis11?.code }}
        </div>
        <div
          *ngIf="visit?.diagnosis12"
          [title]="
            visit?.diagnosis12?.displayName + '&#10;Present On Admission: ' + visit?.diagnosis12PresentOnAdmission
          "
        >
          , {{ visit?.diagnosis12?.code }}
        </div>
      </dd>
      <dt
        *ngIf="visit?.visitReason1DiagnosisCode || visit?.visitReason2DiagnosisCode || visit?.visitReason3DiagnosisCode"
      >
        Visit Reason Diagnosis Codes
      </dt>
      <dd
        class="code-list"
        *ngIf="visit?.visitReason1DiagnosisCode || visit?.visitReason2DiagnosisCode || visit?.visitReason3DiagnosisCode"
      >
        <div
          *ngIf="visit?.visitReason1DiagnosisCode"
          [title]="
            visit?.visitReason1DiagnosisCode?.displayName +
            '&#10;Present On Admission: ' +
            visit?.visitReason1PresentOnAdmission
          "
        >
          {{ visit?.visitReason1DiagnosisCode?.code }}
        </div>
        <div
          *ngIf="visit?.visitReason2DiagnosisCode"
          [title]="
            visit?.visitReason2DiagnosisCode?.displayName +
            '&#10;Present On Admission: ' +
            visit?.visitReason2PresentOnAdmission
          "
        >
          , {{ visit?.visitReason2DiagnosisCode?.code }}
        </div>
        <div
          *ngIf="visit?.visitReason3DiagnosisCode"
          [title]="
            visit?.visitReason3DiagnosisCode?.displayName +
            '&#10;Present On Admission: ' +
            visit?.visitReason3PresentOnAdmission
          "
        >
          , {{ visit?.visitReason3DiagnosisCode?.code }}
        </div>
      </dd>
      <dt *ngIf="visit?.dischargeStatus">Discharge Status</dt>
      <dd *ngIf="visit?.dischargeStatus">
        {{ visit?.dischargeStatus?.displayName || '--' }}
      </dd>
      <dt *ngIf="visit?.occurrenceSpanCode1 || visit?.occurrenceSpanCode2">Occurrence Span Codes</dt>
      <dd *ngIf="visit?.occurrenceSpanCode1 || visit?.occurrenceSpanCode2">
        <div [title]="visit?.occurrenceSpanCode1?.displayName" *ngIf="visit?.occurrenceSpanCode1">
          {{ visit?.occurrenceSpanCode1?.code }} : {{ visit?.occurrenceSpan1FromDate | dateDisplay }} -
          {{ visit?.occurrenceSpan1ToDate | dateDisplay }}
        </div>
        <div [title]="visit?.occurrenceSpanCode2?.displayName" *ngIf="visit?.occurrenceSpanCode2">
          {{ visit?.occurrenceSpanCode2?.code }} : {{ visit?.occurrenceSpan2FromDate | dateDisplay }} -
          {{ visit?.occurrenceSpan2ToDate | dateDisplay }}
        </div>
      </dd>
      <dt *ngIf="visit?.cause1DiagnosisCode || visit?.cause2DiagnosisCode || visit?.cause3DiagnosisCode">
        External Cause of Injury
      </dt>
      <dd
        class="code-list"
        *ngIf="visit?.cause1DiagnosisCode || visit?.cause2DiagnosisCode || visit?.cause3DiagnosisCode"
      >
        <div
          *ngIf="visit?.cause1DiagnosisCode"
          [title]="
            visit?.cause1DiagnosisCode?.displayName + '&#10;Present On Admission: ' + visit?.cause1PresentOnAdmission
          "
        >
          {{ visit?.cause1DiagnosisCode?.code }}
        </div>
        <div
          *ngIf="visit?.cause2DiagnosisCode"
          [title]="
            visit?.cause2DiagnosisCode?.displayName + '&#10;Present On Admission: ' + visit?.cause2PresentOnAdmission
          "
        >
          , {{ visit?.cause2DiagnosisCode?.code }}
        </div>
        <div
          *ngIf="visit?.cause3DiagnosisCode"
          [title]="
            visit?.cause3DiagnosisCode?.displayName + '&#10;Present On Admission: ' + visit?.cause3PresentOnAdmission
          "
        >
          , {{ visit?.cause3DiagnosisCode?.code }}
        </div>
      </dd>
      <dt
        *ngIf="
          visit?.conditionCode1 ||
          visit?.conditionCode2 ||
          visit?.conditionCode3 ||
          visit?.conditionCode4 ||
          visit?.conditionCode5 ||
          visit?.conditionCode6 ||
          visit?.conditionCode7 ||
          visit?.conditionCode8 ||
          visit?.conditionCode9 ||
          visit?.conditionCode10 ||
          visit?.conditionCode11
        "
      >
        Condition Codes
      </dt>
      <dd
        class="code-list"
        *ngIf="
          visit?.conditionCode1 ||
          visit?.conditionCode2 ||
          visit?.conditionCode3 ||
          visit?.conditionCode4 ||
          visit?.conditionCode5 ||
          visit?.conditionCode6 ||
          visit?.conditionCode7 ||
          visit?.conditionCode8 ||
          visit?.conditionCode9 ||
          visit?.conditionCode10 ||
          visit?.conditionCode11
        "
      >
        <div [title]="visit?.conditionCode1?.displayName" *ngIf="visit?.conditionCode1">
          {{ visit?.conditionCode1?.code }}
        </div>
        <div [title]="visit?.conditionCode2?.displayName" *ngIf="visit?.conditionCode2">
          , {{ visit?.conditionCode2?.code }}
        </div>
        <div [title]="visit?.conditionCode3?.displayName" *ngIf="visit?.conditionCode3">
          , {{ visit?.conditionCode3?.code }}
        </div>
        <div [title]="visit?.conditionCode4?.displayName" *ngIf="visit?.conditionCode4">
          , {{ visit?.conditionCode4?.code }}
        </div>
        <div [title]="visit?.conditionCode5?.displayName" *ngIf="visit?.conditionCode5">
          , {{ visit?.conditionCode5?.code }}
        </div>
        <div [title]="visit?.conditionCode6?.displayName" *ngIf="visit?.conditionCode6">
          , {{ visit?.conditionCode6?.code }}
        </div>
        <div [title]="visit?.conditionCode7?.displayName" *ngIf="visit?.conditionCode7">
          , {{ visit?.conditionCode7?.code }}
        </div>
        <div [title]="visit?.conditionCode8?.displayName" *ngIf="visit?.conditionCode8">
          , {{ visit?.conditionCode8?.code }}
        </div>
        <div [title]="visit?.conditionCode9?.displayName" *ngIf="visit?.conditionCode9">
          , {{ visit?.conditionCode9?.code }}
        </div>
        <div [title]="visit?.conditionCode10?.displayName" *ngIf="visit?.conditionCode10">
          , {{ visit?.conditionCode10?.code }}
        </div>
        <div [title]="visit?.conditionCode11?.displayName" *ngIf="visit?.conditionCode11">
          , {{ visit?.conditionCode11?.code }}
        </div>
      </dd>
      <dt *ngIf="visit?.occurrenceCode1 || visit?.occurrenceCode2 || visit?.occurrenceCode3 || visit?.occurrenceCode4">
        Occurrence Codes
      </dt>
      <dd *ngIf="visit?.occurrenceCode1 || visit?.occurrenceCode2 || visit?.occurrenceCode3 || visit?.occurrenceCode4">
        <div [title]="visit?.occurrenceCode1?.displayName" *ngIf="visit?.occurrenceCode1">
          {{ visit?.occurrenceCode1?.code }} : {{ visit?.occurrence1Date | dateDisplay }}
        </div>
        <div [title]="visit?.occurrenceCode2?.displayName" *ngIf="visit?.occurrenceCode2">
          {{ visit?.occurrenceCode2?.code }} : {{ visit?.occurrence2Date | dateDisplay }}
        </div>
        <div [title]="visit?.occurrenceCode3?.displayName" *ngIf="visit?.occurrenceCode3">
          {{ visit?.occurrenceCode3?.code }} : {{ visit?.occurrence3Date | dateDisplay }}
        </div>
        <div [title]="visit?.occurrenceCode4?.displayName" *ngIf="visit?.occurrenceCode4">
          {{ visit?.occurrenceCode4?.code }} : {{ visit?.occurrence4Date | dateDisplay }}
        </div>
      </dd>
      <dt *ngIf="visit?.drgDiagnosisCode">DRG Diagnosis</dt>
      <dd
        [title]="visit?.drgDiagnosisCode?.displayName + '&#10;Present On Admission: ' + visit?.drgPresentOnAdmission"
        *ngIf="visit?.drgDiagnosisCode"
      >
        {{ visit?.drgDiagnosisCode?.code }}
      </dd>
      <dt *ngIf="visit?.valueCode1 || visit?.valueCode2 || visit?.valueCode3">Value Codes</dt>
      <dd *ngIf="visit?.valueCode1 || visit?.valueCode2 || visit?.valueCode3">
        <div [title]="visit?.valueCode1?.displayName" *ngIf="visit?.valueCode1">
          {{ visit?.valueCode1?.code }} : {{ visit?.value1Amount | currency }}
        </div>
        <div [title]="visit?.valueCode2?.displayName" *ngIf="visit?.valueCode2">
          {{ visit?.valueCode2?.code }} : {{ visit?.value2Amount | currency }}
        </div>
        <div [title]="visit?.valueCode3?.displayName" *ngIf="visit?.valueCode3">
          {{ visit?.valueCode3?.code }} : {{ visit?.value3Amount | currency }}
        </div>
      </dd>

      <dt *ngIf="visit?.billingNote">Billing Note</dt>
      <dd *ngIf="visit?.billingNote">{{ visit?.billingNote }}</dd>
      <dt *ngIf="visit?.claimNote1">{{ visit?.claimNoteType1Display }}</dt>
      <dd *ngIf="visit?.claimNote1">{{ visit?.claimNote1 }}</dd>
      <dt *ngIf="visit?.claimNote2">{{ visit?.claimNoteType2Display }}</dt>
      <dd *ngIf="visit?.claimNote2">{{ visit?.claimNote2 }}</dd>
      <dt *ngIf="visit?.claimNote3">{{ visit?.claimNoteType3Display }}</dt>
      <dd *ngIf="visit?.claimNote3">{{ visit?.claimNote3 }}</dd>
      <dt *ngIf="visit?.claimNote4">{{ visit?.claimNoteType4Display }}</dt>
      <dd *ngIf="visit?.claimNote4">{{ visit?.claimNote4 }}</dd>
      <dt *ngIf="visit?.claimNote5">{{ visit?.claimNoteType5Display }}</dt>
      <dd *ngIf="visit?.claimNote5">{{ visit?.claimNote5 }}</dd>
      <dt *ngIf="visit?.claimNote6">{{ visit?.claimNoteType6Display }}</dt>
      <dd *ngIf="visit?.claimNote6">{{ visit?.claimNote6 }}</dd>
      <dt *ngIf="visit?.claimNote7">{{ visit?.claimNoteType7Display }}</dt>
      <dd *ngIf="visit?.claimNote7">{{ visit?.claimNote7 }}</dd>
      <dt *ngIf="visit?.claimNote8">{{ visit?.claimNoteType8Display }}</dt>
      <dd *ngIf="visit?.claimNote8">{{ visit?.claimNote8 }}</dd>
      <dt *ngIf="visit?.claimNote9">{{ visit?.claimNoteType9Display }}</dt>
      <dd *ngIf="visit?.claimNote9">{{ visit?.claimNote9 }}</dd>
      <dt *ngIf="visit?.claimNote10">{{ visit?.claimNoteType10Display }}</dt>
      <dd *ngIf="visit?.claimNote10">{{ visit?.claimNote10 }}</dd>
    </dl>
  </lib-card>
</div>
